export default "__VITE_ASSET__yML8C1pN__"